module.exports = __webpack_public_path__ + "fonts/MuseoSansCyrl-700.1f87040.otf";